import Loader from '@superfunnel/ui-core/Loader';
import ConfiguredSectionPlaceholder from './ConfiguredSectionPlaceholder';

const DomainCardPlaceholder = () => {
  return (
    <div className="mt-10 w-full border-y border-black py-10 sm:rounded-lg sm:border sm:border-gray-50 sm:shadow-md">
      <div className="flex justify-between space-x-4 px-2 sm:px-10">
        <div className="h-7 w-36 animate-pulse rounded-md bg-gray-300" />
        <div className="flex space-x-3">
          <button
            disabled={true}
            className="w-24 cursor-not-allowed rounded-md border border-solid border-gray-200 bg-gray-100 py-1.5 text-sm text-gray-500 transition-all duration-150 ease-in-out focus:outline-hidden"
          >
            <Loader />
          </button>
          <button
            disabled={true}
            className="w-24 rounded-md border border-solid border-red-500 bg-red-500 py-1.5 text-sm text-white transition-all duration-150 ease-in-out hover:bg-white hover:text-red-500 focus:outline-hidden"
          ></button>
        </div>
      </div>
      <ConfiguredSectionPlaceholder />
    </div>
  );
};

export default DomainCardPlaceholder;
